module.exports = __webpack_public_path__ + "img/img1.f14d93f6.png";